import { Component, Input, OnInit } from '@angular/core';
import { Constants } from 'src/app/shared/utils/constants';
import { CmsService } from '../../cms.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TradingHistoryComponent } from '../../customers/training-history/training-history.component';

@Component({
  selector: 'fx-trader-balance',
  templateUrl: './trader-balance.component.html',
  styleUrls: ['./trader-balance.component.sass']
})
export class TraderBalanceComponent implements OnInit {
  @Input() data: any = {};
  pageInfo = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  bonusInfo:any;
  fixedNumber = Constants.FIXED_NUMBER;
  year = new Date().getFullYear();
  constructor(
    private service: CmsService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.data.totalVolume=Number(this.data.totalVolume).toFixed(2);
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getBonusDetail();
  }

  getPercentBalanceRatio(): string {
    if (this.data.totalBalance !== undefined && this.data.totalPNL !== undefined && this.data.totalBalance !==  0 && this.data.totalPNL !== 0) {
      return ((this.data.totalPNL / this.data.totalBalance) * 100).toFixed(2) + ' %';
    }
    return '0';
  }

  getBonusDetail(): void {
    const params = {
      user_id: this.data.id,
      mt5_loign: this.data.login,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getBonusDetail(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        res.data.bonus_events.forEach(e => {
            e.status =  ((e.end_time - new Date(Date.now()).getTime())) > 0 ? 'On going' : 'Expired'
        });
        this.bonusInfo=res.data.bonus_events;
        this.pageInfo.totalRecord = res.data.paging.total;
      }
    });
  }

  getBonusContribution(item){
    if (!item.mt5Account || !item.total_bonus_used) {
      return ;
    }
    const dialog = this.dialogService?.open(TradingHistoryComponent, {
      header: "TRADING HISTORY",
      showHeader: true,
      width: '60%',
      data: item
    });
    dialog?.onClose.subscribe({
      next: (isSuccess) => {
        if (isSuccess) {
          
        }
      },
    });
  }

}
